import React, { useEffect } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';

const PasswordChange = () => {
    const [oldPassword, setOldPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState(false);
    const [edit, setEdit] = React.useState(false);

    function submit(e: React.SyntheticEvent) {
        e.preventDefault();
        axios.post(`${process.env.API_URL}/api/account/updatepassword`, {
            oldPassword,
            newPassword,
        }, {
            withCredentials: true,
        })
            .then((response) => {
                setSuccess(true);
                setError('');
            })
            .catch((e) => {
                if (!e.response || !e.response.data.errors) {
                    return setError('Server Error');
                }
                return setError(e.response.data.errors[0].msg);
            });
    }

    useEffect(() => {
        if (success) {
            setTimeout(() => {
                setSuccess(false);
            }, 5000);
        }
    }, [success]);

    useEffect(() => {
        if (!edit) {
            setOldPassword('');
            setNewPassword('');
            setError('');
            setSuccess(false);
        }
    }, [edit]);

    return (
        <>
            {
                edit ? (
                    <>
                        <form onSubmit={submit} className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="firstName">Old Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="oldpassword"
                                    value={oldPassword}
                                    placeholder="Old Password"
                                    onChange={e => setOldPassword(e.target.value)}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="lastName">New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="newpassword"
                                    value={newPassword}
                                    placeholder="New Password"
                                    onChange={e => setNewPassword(e.target.value)}
                                />
                            </div>
                            <br />
                            <div className="col-3 d-flex">
                                <Button
                                    type="submit"
                                    disabled={newPassword === '' || oldPassword === ''}
                                >
                                    Update
                                </Button>
                                &nbsp;
                                <Button onClick={() => setEdit(false)}>Cancel</Button>
                            </div>
                        </form>
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">Password Updated</div>}
                    </>
                ) : (
                    <Button onClick={() => setEdit(true)}>Change Password</Button>
                )
            }
        </>
    );
};

export default PasswordChange;
